import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';

type OrgStatus = 'active' | 'past_due' | 'suspended' | null | undefined;

const STATUS_CLASSES: Record<NonNullable<OrgStatus>, string> = {
  active: 'border-emerald-500/30 bg-emerald-500/10 text-emerald-500',
  past_due: 'border-amber-500/30 bg-amber-500/10 text-amber-500',
  suspended: 'border-red-500/30 bg-red-500/10 text-red-500',
};

export function StatusBadge({ status, className }: { status: OrgStatus; className?: string }) {
  const value = status ?? 'active';
  return (
    <Badge
      variant="outline"
      className={cn('uppercase tracking-wide', STATUS_CLASSES[value], className)}
    >
      {value}
    </Badge>
  );
}
